import _ from "lodash";
import {
  EU_PORTAL_TYPE,
  US_PORTAL_TYPE,
  ME_PORTAL_TYPE,
  AU_PORTAL_TYPE,
  CN_PORTAL_TYPE,
  SG_PORTAL_TYPE,
  HK_PORTAL_TYPE,
  EU_CENTRAL_PORTAL_TYPE,
} from "Constants";
import { setUserIdentityDetails } from "Login/modules/LoginModule";
import { getIsChina } from "config";

export const REGION_FILTER_OPTIONS = getIsChina()
  ? [
      {
        label: "China",
        value: 5,
      },
    ]
  : [
      {
        label: "Europe",
        value: 1,
      },
      {
        label: "USA",
        value: 2,
      },
      {
        label: "Middle East",
        value: 3,
      },
      {
        label: "Australia",
        value: 4,
      },
      {
        label: "Singapore",
        value: 6,
      },
      {
        label: "Hong Kong",
        value: 7,
      },
    ];

export const REGION_OPTIONS = getIsChina()
  ? [
      {
        label: "China",
        value: CN_PORTAL_TYPE,
      },
    ]
  : [
      {
        label: "Europe",
        value: EU_PORTAL_TYPE,
      },
      {
        label: "USA",
        value: US_PORTAL_TYPE,
      },
      {
        label: "Middle East",
        value: ME_PORTAL_TYPE,
      },
      {
        label: "Australia",
        value: AU_PORTAL_TYPE,
      },
      {
        label: "Singapore",
        value: SG_PORTAL_TYPE,
      },
      {
        label: "Hong Kong",
        value: HK_PORTAL_TYPE,
      },
    ];

const REGION_LOGO_BY_PORTAL_TYPE = {
  ["TOOL_EU_WEST_1"]:
    "https://cloud.toddleapp.com/us-east-1/s/content/tPR_SNocJ.png",
  ["TOOL_US_EAST_1"]:
    "https://cloud.toddleapp.com/us-east-1/s/content/jXRXQikcU.png",
  ["TOOL_ME_CENTRAL_1"]:
    "https://cloud.toddleapp.com/eu-west-1/s/content/v5tmD0qXX.png",
  ["TOOL_EU_CENTRAL_1"]:
    "https://cloud.toddleapp.com/eu-west-1/s/content/v5tmD0qXX.png",
  ["TOOL_AP_SOUTHEAST_2"]:
    "https://cloud.toddleapp.com/eu-west-1/s/content/cYUPqqjpG.jpeg",
  ["TOOL_AP_SOUTHEAST_1"]:
    "https://cloud.toddleapp.com/assets/flags/singapore_flag.png",
  ["TOOL_AP_EAST_1"]:
    "https://cloud.toddleapp.com/assets/flags/hong_kong_flag.jpg",
  ["TOOL_CN_NORTH_1"]: "https://cloud.toddleapp.cn/assets/flags/china_flag.jpg",
  ["COMMON"]: "https://cloud.toddleapp.com/us-east-1/s/content/Z3Ap94OqC.png",
};

export const REGION_NAME_BY_REGION = {
  ["eu-west-1"]: "Europe",
  ["us-east-1"]: "USA",
  ["me-central-1"]: "Middle East",
  ["eu-central-1"]: "Middle East",
  ["ap-southeast-2"]: "Australia",
  ["ap-southeast-1"]: "Singapore",
  ["ap-east-1"]: "Hong Kong",
  ["cn-north-1"]: "China",
};

export const PORTAL_TYPE_BY_REGION = {
  ["eu-west-1"]: EU_PORTAL_TYPE,
  ["us-east-1"]: US_PORTAL_TYPE,
  ["me-central-1"]: ME_PORTAL_TYPE,
  ["eu-central-1"]: EU_CENTRAL_PORTAL_TYPE,
  ["ap-southeast-2"]: AU_PORTAL_TYPE,
  ["ap-southeast-1"]: SG_PORTAL_TYPE,
  ["ap-east-1"]: HK_PORTAL_TYPE,
  ["cn-north-1"]: CN_PORTAL_TYPE,
};

export const REGION_NAME_BY_PORTAL_TYPE = {
  [EU_PORTAL_TYPE]: "Europe",
  [US_PORTAL_TYPE]: "USA",
  [ME_PORTAL_TYPE]: "Middle East",
  [AU_PORTAL_TYPE]: "Australia",
  [SG_PORTAL_TYPE]: "Singapore",
  [HK_PORTAL_TYPE]: "Hong Kong",
  [CN_PORTAL_TYPE]: "China",
  ["COMMON"]: "Other Tools",
};

export const addToolingIdentitiesInRedux = ({ toolingUserInfo }) => {
  return async (dispatch, getState) => {
    const state = getState();

    const userIdentityDetails = _.get(state, "login.userIdentityDetails", []);

    const toolingUserIdentities = _.map(
      _.get(toolingUserInfo, "userIdentityDetails", []),
      ({ portalType, linkedUser }) => {
        return {
          ...linkedUser,
          token: linkedUser.jwt,
          portalType,
        };
      }
    );

    /**
     * First remove all tooling identities and then add latest tooling identities
     */
    const updatedIdentityDetails = [
      ..._.filter(userIdentityDetails, ({ portalType }) => {
        return (
          _.findIndex(
            toolingUserIdentities,
            ({ portalType: toolingPortalType }) =>
              toolingPortalType === portalType
          ) === -1
        );
      }),
      ...toolingUserIdentities,
    ];

    dispatch(setUserIdentityDetails(updatedIdentityDetails));
  };
};

export const getRegionList = ({ userInfo, excludeCommonRegion = false }) => {
  const userIdentityDetails = _.get(userInfo, "userIdentityDetails", []);

  let regionList = [];

  if (!excludeCommonRegion) {
    regionList.push({
      id: "COMMON_REGION",
      portalType: "COMMON",
      logo: REGION_LOGO_BY_PORTAL_TYPE["COMMON"],
      name: REGION_NAME_BY_PORTAL_TYPE["COMMON"],
      region: "common",
    });
  }

  regionList = [
    ...regionList,
    ..._.map(
      userIdentityDetails,
      ({ portalType, linkedUser: { id, region } }) => {
        return {
          name: REGION_NAME_BY_PORTAL_TYPE[portalType],
          portalType,
          id,
          logo: REGION_LOGO_BY_PORTAL_TYPE[portalType],
          region,
        };
      }
    ),
  ];

  return regionList;
};
